// fechasUY.js
// Utilidades de fecha ancladas a la hora de Uruguay (America/Montevideo).
// Usar Intl con esta zona horaria garantiza que "hoy" y las fechas se
// calculen siempre según Uruguay, sin importar el navegador o el país
// desde donde se abra la web.

export const TZ_UY = "America/Montevideo";

// "Hoy" según el calendario de Uruguay. Devuelve una fecha local anclada
// al mediodía, para que las comparaciones por día calendario sean estables.
export function hoyUY() {
  const ymd = new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ_UY,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date()); // "YYYY-MM-DD" en hora de Uruguay
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y, m - 1, d, 12, 0, 0, 0);
}

// Formatea una fecha como dd/MM/yyyy (u otras opciones de Intl) en hora de Uruguay.
export function formatFechaUY(fecha, opciones = {}) {
  if (!fecha) return "";
  return new Intl.DateTimeFormat("es-UY", {
    timeZone: TZ_UY,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...opciones,
  }).format(fecha);
}